import { createContext } from 'react';

/**
 * Fields whose own rule fails but whose editor does not mark it yet, such as a SCADA list
 * with a row just added. A form that blocks its save on rule errors reads these, so its
 * message does not point at marks that are not there.
 */
export interface HeldBackFields {
    setHeld: (name: string, held: boolean) => void;
}

export const HeldBackFieldsContext = createContext<HeldBackFields | null>(null);
